"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Variant = exports.Product = exports.Kind = void 0;
var _GlobalKind = _interopRequireDefault(require("../type-tools/GlobalKind"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Product = exports.Product = /*#__PURE__*/function (Product) {
  Product["QUINTOANDAR"] = "QuintoAndar";
  Product["INMUEBLES24"] = "inmuebles24";
  return Product;
}(Product || {});
var Variant = exports.Variant = /*#__PURE__*/function (Variant) {
  Variant["SYMBOL"] = "symbol";
  Variant["WORDMARK"] = "wordmark";
  Variant["COMPLETE"] = "complete";
  return Variant;
}(Variant || {});
var Kind = exports.Kind = function (Kind) {
  Kind[Kind["DEFAULT"] = _GlobalKind["default"].DEFAULT] = "DEFAULT";
  Kind[Kind["INVERSE"] = _GlobalKind["default"].INVERSE] = "INVERSE";
  return Kind;
}(Kind || {});